/* generated by pull.js */
const manifest = {
  noTranslations: true,
  name: 'Display stage on left side',
  description: 'Moves the stage to the left side of the editor, like in Scratch 2.0.',
  info: [
    {
      id: 'reverseOrder',
      text: 'To change the position of buttons above the stage, use the "reverse order of project controls" addon.'
    }
  ],
  credits: [
    {
      name: 'NitroCipher/ZenithRogue'
    }
  ],
  userscripts: [
    {
      url: 'fix-share-the-love.js'
    }
  ],
  dynamicDisable: true,
  userstyles: [
    {
      url: 'stageleft.css'
    }
  ],
  tags: ['theme'],
  enabledByDefault: false
};
export default manifest;
